/** Regex that matches a group of characters between two parentheses */
export const PARENTHESES_AROUND_STRING_REGEX = /^\((.*)\)$/;

/**
 * Checks that the given string is surrounded by parentheses
 */
export const isBetweenParentheses = (string: string) => {
    return PARENTHESES_AROUND_STRING_REGEX.test(string);
};
